// extracted by mini-css-extract-plugin
export default {"otpContainer":"styles_otpContainer__Nr4DX","otpInput":"styles_otpInput__imP5Z"};